import {use} from 'react'
import type {
  EstablishedAhpSession,
  EstablishedAhpSessionCommands,
  EstablishedAhpSessionInputController,
  EstablishedAhpSessionLifecycle,
  EstablishedAhpSessionPlanning,
  EstablishedAhpSessionView,
} from '@github-ui/ahp-session-client/contracts'

import {EstablishedAhpSessionContext} from '../contexts/EstablishedAhpSessionContext'

export function useOptionalEstablishedAhpSession(): EstablishedAhpSession | undefined {
  return use(EstablishedAhpSessionContext)
}

export function useEstablishedAhpSession(): EstablishedAhpSession {
  const session = use(EstablishedAhpSessionContext)
  if (!session) {
    throw new Error('useEstablishedAhpSession must be used within EstablishedAhpSessionProvider')
  }
  return session
}

export function useEstablishedAhpSessionView(): EstablishedAhpSessionView {
  return useEstablishedAhpSession().view
}

export function useEstablishedAhpSessionInput(): EstablishedAhpSessionInputController {
  return useEstablishedAhpSession().input
}

export function useEstablishedAhpSessionCommands(): EstablishedAhpSessionCommands {
  return useEstablishedAhpSession().commands
}

export function useEstablishedAhpSessionPlanning(): EstablishedAhpSessionPlanning | undefined {
  return useEstablishedAhpSession().planning
}

export function useEstablishedAhpSessionLifecycle(): EstablishedAhpSessionLifecycle {
  return useEstablishedAhpSession().lifecycle
}
